/*run-generator-name*/
/*flag-options*/
/*--args*/
/*--config-path*/
/*--root-path*/
/*workspace*/
/*flag-options-1*/
/*--name-name*/
/*--empty*/
/*--copy-nameurl*/
/*--destination-path*/
/*--type-apppackage*/
/*--root-path-1*/
/*--show-all-dependencies*/
/*--example-path-path--p-path*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "generate",
  "description": "`turbo generate` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "使用新的应用和包扩展你的 Turborepo。"
  }, {
    "heading": "",
    "content": "¥Extend your Turborepo with new apps and packages."
  }, {
    "heading": "",
    "content": "turbo generate run [generator-name]：运行你仓库中定义的自定义生成器。"
  }, {
    "heading": "",
    "content": "¥turbo generate run [generator-name]: Run custom generators defined in your repository."
  }, {
    "heading": "",
    "content": "turbo generate workspace [options]：通过复制现有包或从头开始，在你的代码库中创建一个新包。"
  }, {
    "heading": "",
    "content": "¥turbo generate workspace [options]: Create a new package in your repository by copying an existing one or from the start."
  }, {
    "heading": "",
    "content": "更多有关编写自定义生成器的信息和实际用例，请访问 \"生成代码\" 指南。"
  }, {
    "heading": "",
    "content": "¥For more information and practical use cases for writing custom generators, visit the \"Generating code\" guide."
  }, {
    "heading": "",
    "content": "turbo gen 是 turbo generate 的别名。此外，run 是默认命令，因此 turbo gen 等同于 turbo generate run。"
  }, {
    "heading": "",
    "content": "¥turbo gen is an alias for turbo generate. Additionally, run is the\ndefault command so turbo gen is equivalent to turbo generate run."
  }, {
    "heading": "run-generator-name-run-generator-name",
    "content": "运行你仓库中定义的自定义生成器。"
  }, {
    "heading": "run-generator-name-run-generator-name",
    "content": "¥Run custom generators defined in your repository."
  }, {
    "heading": "标志选项-flag-options",
    "content": "¥Flag options"
  }, {
    "heading": "--args---args",
    "content": "直接传递给生成器提示的答案。"
  }, {
    "heading": "--args---args",
    "content": "¥Answers to pass directly to the generator's prompts."
  }, {
    "heading": "--config-path---config-path",
    "content": "生成器配置文件。"
  }, {
    "heading": "--config-path---config-path",
    "content": "¥Generator configuration file."
  }, {
    "heading": "--config-path---config-path",
    "content": "默认：turbo/generators/config.js"
  }, {
    "heading": "--config-path---config-path",
    "content": "¥Default: turbo/generators/config.js"
  }, {
    "heading": "--root-path---root-path",
    "content": "仓库的根目录"
  }, {
    "heading": "--root-path---root-path",
    "content": "¥The root of your repository"
  }, {
    "heading": "--root-path---root-path",
    "content": "默认：根目录为 turbo.json"
  }, {
    "heading": "--root-path---root-path",
    "content": "¥Default: directory with root turbo.json"
  }, {
    "heading": "workspace-workspace",
    "content": "创建一个新的工作区。"
  }, {
    "heading": "workspace-workspace",
    "content": "¥Create a new workspace."
  }, {
    "heading": "标志选项-flag-options-1",
    "content": "¥Flag options"
  }, {
    "heading": "--name-name---name-name",
    "content": "package.json name 键中要使用的新工作区名称。name 键是仓库中软件包的唯一标识符。"
  }, {
    "heading": "--name-name---name-name",
    "content": "¥The name for the new workspace to be used in the package.json name key. The name key is the unique identifier for the package in your repository."
  }, {
    "heading": "--empty---empty",
    "content": "创建一个空的工作区。默认为 true。"
  }, {
    "heading": "--empty---empty",
    "content": "¥Creates an empty workspace. Defaults to true."
  }, {
    "heading": "--copy-nameurl---copy-nameurl",
    "content": "monorepo 中的本地工作区名称，或包含任何分支和/或子目录的完整 GitHub URL。"
  }, {
    "heading": "--copy-nameurl---copy-nameurl",
    "content": "¥Name of local workspace within your monorepo or a fully qualified GitHub URL with any branch and/or subdirectory."
  }, {
    "heading": "--destination-path---destination-path",
    "content": "应在何处创建新的工作区。"
  }, {
    "heading": "--destination-path---destination-path",
    "content": "¥Where the new workspace should be created."
  }, {
    "heading": "--type-apppackage---type-apppackage",
    "content": "要创建的工作区类型（app 或 package）。"
  }, {
    "heading": "--type-apppackage---type-apppackage",
    "content": "¥The type of workspace to create (app or package)."
  }, {
    "heading": "--root-path---root-path-1",
    "content": "仓库的根目录。默认为根目录 turbo.json 目录。"
  }, {
    "heading": "--root-path---root-path-1",
    "content": "¥The root of your repository. Defaults to the directory of the root turbo.json."
  }, {
    "heading": "--show-all-dependencies---show-all-dependencies",
    "content": "选择要添加的依赖时，避免按工作区类型筛选依赖。"
  }, {
    "heading": "--show-all-dependencies---show-all-dependencies",
    "content": "¥Prevent filtering dependencies by workspace type when selecting dependencies to add."
  }, {
    "heading": "--example-path-path--p-path---example-path-path--p-path",
    "content": "在极少数情况下，你的 GitHub URL 可能包含带斜杠的分支名称（例如 bug/fix-1）和示例路径（例如 foo/bar）。在这种情况下，你必须单独指定示例的路径。"
  }, {
    "heading": "--example-path-path--p-path---example-path-path--p-path",
    "content": "¥In a rare case, your GitHub URL might contain a branch name with a slash (e.g. bug/fix-1) and the path to the example (e.g. foo/bar). In this case, you must specify the path to the example separately."
  }],
  "headings": [{
    "id": "run-generator-name-run-generator-name",
    "content": "run [generator-name] /*run-generator-name*/"
  }, {
    "id": "标志选项-flag-options",
    "content": "标志选项 /*flag-options*/"
  }, {
    "id": "--args---args",
    "content": "--args /*--args*/"
  }, {
    "id": "--config-path---config-path",
    "content": "--config <path> /*--config-path*/"
  }, {
    "id": "--root-path---root-path",
    "content": "--root <path> /*--root-path*/"
  }, {
    "id": "workspace-workspace",
    "content": "workspace /*workspace*/"
  }, {
    "id": "标志选项-flag-options-1",
    "content": "标志选项 /*flag-options-1*/"
  }, {
    "id": "--name-name---name-name",
    "content": "--name <name> /*--name-name*/"
  }, {
    "id": "--empty---empty",
    "content": "--empty /*--empty*/"
  }, {
    "id": "--copy-nameurl---copy-nameurl",
    "content": "--copy <name>/<url> /*--copy-nameurl*/"
  }, {
    "id": "--destination-path---destination-path",
    "content": "--destination <path> /*--destination-path*/"
  }, {
    "id": "--type-apppackage---type-apppackage",
    "content": "--type <app/package> /*--type-apppackage*/"
  }, {
    "id": "--root-path---root-path-1",
    "content": "--root <path> /*--root-path-1*/"
  }, {
    "id": "--show-all-dependencies---show-all-dependencies",
    "content": "--show-all-dependencies /*--show-all-dependencies*/"
  }, {
    "id": "--example-path-path--p-path---example-path-path--p-path",
    "content": "--example-path <path>, -p <path> /*--example-path-path--p-path*/"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#run-generator-name-run-generator-name",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "run [generator-name]"
    }), " "]
  })
}, {
  depth: 3,
  url: "#标志选项-flag-options",
  title: _jsx(_Fragment, {
    children: "标志选项 "
  })
}, {
  depth: 4,
  url: "#--args---args",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--args"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--config-path---config-path",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--config <path>"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--root-path---root-path",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--root <path>"
    }), " "]
  })
}, {
  depth: 2,
  url: "#workspace-workspace",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "workspace"
    }), " "]
  })
}, {
  depth: 3,
  url: "#标志选项-flag-options-1",
  title: _jsx(_Fragment, {
    children: "标志选项 "
  })
}, {
  depth: 4,
  url: "#--name-name---name-name",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--name <name>"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--empty---empty",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--empty"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--copy-nameurl---copy-nameurl",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--copy <name>/<url>"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--destination-path---destination-path",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--destination <path>"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--type-apppackage---type-apppackage",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--type <app/package>"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--root-path---root-path-1",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--root <path>"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--show-all-dependencies---show-all-dependencies",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--show-all-dependencies"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--example-path-path--p-path---example-path-path--p-path",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--example-path <path>"
    }), ", ", _jsx("code", {
      children: "-p <path>"
    }), " "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "使用新的应用和包扩展你的 Turborepo。"
    }), "\n", _jsx(_components.p, {
      children: "¥Extend your Turborepo with new apps and packages."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " generate"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "#run-generator-name",
            children: _jsx(_components.code, {
              children: "turbo generate run [generator-name]"
            })
          }), "：运行你仓库中定义的自定义生成器。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#run-generator-name",
            children: _jsx(_components.code, {
              children: "turbo generate run [generator-name]"
            })
          }), ": Run custom generators defined in your repository."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "#workspace",
            children: _jsx(_components.code, {
              children: "turbo generate workspace [options]"
            })
          }), "：通过复制现有包或从头开始，在你的代码库中创建一个新包。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#workspace",
            children: _jsx(_components.code, {
              children: "turbo generate workspace [options]"
            })
          }), ": Create a new package in your repository by copying an existing one or from the start."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["更多有关编写自定义生成器的信息和实际用例，请访问 ", _jsx(_components.a, {
        href: "/docs/guides/generating-code",
        children: "\"生成代码\" 指南"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For more information and practical use cases for writing custom generators, visit ", _jsx(_components.a, {
        href: "/docs/guides/generating-code",
        children: "the \"Generating code\" guide"
      }), "."]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo gen"
        }), " 是 ", _jsx(_components.code, {
          children: "turbo generate"
        }), " 的别名。此外，", _jsx(_components.code, {
          children: "run"
        }), " 是默认命令，因此 ", _jsx(_components.code, {
          children: "turbo gen"
        }), " 等同于 ", _jsx(_components.code, {
          children: "turbo generate run"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: "turbo gen"
        }), " is an alias for ", _jsx(_components.code, {
          children: "turbo generate"
        }), ". Additionally, ", _jsx(_components.code, {
          children: "run"
        }), " is the\ndefault command so ", _jsx(_components.code, {
          children: "turbo gen"
        }), " is equivalent to ", _jsx(_components.code, {
          children: "turbo generate run"
        }), "."]
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "run-generator-name-run-generator-name",
      children: [_jsx(_components.code, {
        children: "run [generator-name]"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "运行你仓库中定义的自定义生成器。"
    }), "\n", _jsx(_components.p, {
      children: "¥Run custom generators defined in your repository."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [generator-name]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "标志选项-flag-options",
      children: "标志选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Flag options"
    }), "\n", _jsxs(_components.h4, {
      id: "--args---args",
      children: [_jsx(_components.code, {
        children: "--args"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "直接传递给生成器提示的答案。"
    }), "\n", _jsx(_components.p, {
      children: "¥Answers to pass directly to the generator's prompts."
    }), "\n", _jsxs(_components.h4, {
      id: "--config-path---config-path",
      children: [_jsx(_components.code, {
        children: "--config <path>"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "生成器配置文件。"
    }), "\n", _jsx(_components.p, {
      children: "¥Generator configuration file."
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "turbo/generators/config.js"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "turbo/generators/config.js"
      })]
    }), "\n", _jsxs(_components.h4, {
      id: "--root-path---root-path",
      children: [_jsx(_components.code, {
        children: "--root <path>"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "仓库的根目录"
    }), "\n", _jsx(_components.p, {
      children: "¥The root of your repository"
    }), "\n", _jsxs(_components.p, {
      children: ["默认：根目录为 ", _jsx(_components.code, {
        children: "turbo.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: directory with root ", _jsx(_components.code, {
        children: "turbo.json"
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "workspace-workspace",
      children: [_jsx(_components.code, {
        children: "workspace"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "创建一个新的工作区。"
    }), "\n", _jsx(_components.p, {
      children: "¥Create a new workspace."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " workspace"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [options]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "标志选项-flag-options-1",
      children: "标志选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Flag options"
    }), "\n", _jsxs(_components.h4, {
      id: "--name-name---name-name",
      children: [_jsx(_components.code, {
        children: "--name <name>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "package.json"
      }), " ", _jsx(_components.code, {
        children: "name"
      }), " 键中要使用的新工作区名称。", _jsx(_components.code, {
        children: "name"
      }), " 键是仓库中软件包的唯一标识符。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The name for the new workspace to be used in the ", _jsx(_components.code, {
        children: "package.json"
      }), " ", _jsx(_components.code, {
        children: "name"
      }), " key. The ", _jsx(_components.code, {
        children: "name"
      }), " key is the unique identifier for the package in your repository."]
    }), "\n", _jsxs(_components.h4, {
      id: "--empty---empty",
      children: [_jsx(_components.code, {
        children: "--empty"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["创建一个空的工作区。默认为 ", _jsx(_components.code, {
        children: "true"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Creates an empty workspace. Defaults to ", _jsx(_components.code, {
        children: "true"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "--copy-nameurl---copy-nameurl",
      children: [_jsx(_components.code, {
        children: "--copy <name>/<url>"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "monorepo 中的本地工作区名称，或包含任何分支和/或子目录的完整 GitHub URL。"
    }), "\n", _jsx(_components.p, {
      children: "¥Name of local workspace within your monorepo or a fully qualified GitHub URL with any branch and/or subdirectory."
    }), "\n", _jsxs(_components.h4, {
      id: "--destination-path---destination-path",
      children: [_jsx(_components.code, {
        children: "--destination <path>"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "应在何处创建新的工作区。"
    }), "\n", _jsx(_components.p, {
      children: "¥Where the new workspace should be created."
    }), "\n", _jsxs(_components.h4, {
      id: "--type-apppackage---type-apppackage",
      children: [_jsx(_components.code, {
        children: "--type <app/package>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["要创建的工作区类型（", _jsx(_components.code, {
        children: "app"
      }), " 或 ", _jsx(_components.code, {
        children: "package"
      }), "）。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The type of workspace to create (", _jsx(_components.code, {
        children: "app"
      }), " or ", _jsx(_components.code, {
        children: "package"
      }), ")."]
    }), "\n", _jsxs(_components.h4, {
      id: "--root-path---root-path-1",
      children: [_jsx(_components.code, {
        children: "--root <path>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["仓库的根目录。默认为根目录 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 目录。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The root of your repository. Defaults to the directory of the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "--show-all-dependencies---show-all-dependencies",
      children: [_jsx(_components.code, {
        children: "--show-all-dependencies"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "选择要添加的依赖时，避免按工作区类型筛选依赖。"
    }), "\n", _jsx(_components.p, {
      children: "¥Prevent filtering dependencies by workspace type when selecting dependencies to add."
    }), "\n", _jsxs(_components.h4, {
      id: "--example-path-path--p-path---example-path-path--p-path",
      children: [_jsx(_components.code, {
        children: "--example-path <path>"
      }), ", ", _jsx(_components.code, {
        children: "-p <path>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["在极少数情况下，你的 GitHub URL 可能包含带斜杠的分支名称（例如 ", _jsx(_components.code, {
        children: "bug/fix-1"
      }), "）和示例路径（例如 ", _jsx(_components.code, {
        children: "foo/bar"
      }), "）。在这种情况下，你必须单独指定示例的路径。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In a rare case, your GitHub URL might contain a branch name with a slash (e.g. ", _jsx(_components.code, {
        children: "bug/fix-1"
      }), ") and the path to the example (e.g. ", _jsx(_components.code, {
        children: "foo/bar"
      }), "). In this case, you must specify the path to the example separately."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
